import { ExternalExaminer } from "@/shared/modules/typescript-trustapi-client/models";
import { Module } from "vuex";

const externalExaminerStoreModule: Module<any, any> = {
  state: {
    selectedEE: {},
  },
  mutations: {
    setSelectedEE(state, i: ExternalExaminer) {
      state.selectedEE = i;
    }
  },
  actions: {
    setSelectedEE({ commit }, i: ExternalExaminer) {
      commit('setSelectedEE', i);
    }
  },
  getters: {
    getSelectedEE: (state) => state.selectedEE,
  }
}
export default externalExaminerStoreModule;